export default {
  brokenLinks: []
}
